export const TIER_LABELS: Record<string, string> = {
  free: 'Free',
  starter: 'Starter',
  pro: 'Pro',
  family: 'Family',
  lifetime: 'Lifetime',
  lifetime_access: 'Lifetime Access',
  complimentary_starter: 'Complimentary Starter',
  complimentary_pro: 'Complimentary Pro',
};

export const TIER_DESCRIPTIONS: Record<string, string> = {
  free: 'Try out and save time!',
  starter: 'Basic features to get you started.',
  pro: 'Only for the most advanced producers.',
  family: 'Share Pro features with up to 3 family members.',
  lifetime: 'One-time payment for lifetime access',
  lifetime_access: 'One-time payment for lifetime access',
  complimentary_starter: 'Basic features to get you started.',
  complimentary_pro: 'Only for the most advanced producers.',
};

export interface SubscriptionLimit {
  tier: string;
  daily_instant_upload_limit: number | null;
  daily_scheduled_upload_limit: number | null;
  allow_scheduled_uploads: boolean;
  allow_upload_defaults: boolean;
  features: Record<string, boolean>; // Dynamic features from database
}

export interface PayPalPlan {
  id: number;
  paypal_plan_id: string;
  tier: string;
  billing_cycle: string;
  price: number | null;
  base_price: number | null;
  discounted_price: number | null;
  discount_percentage: number | null;
  twelve_x_monthly_price: number | null;
  annual_savings_percentage: number | null;
  currency_code: string;
  description: string | null;
  paypal_plan_name: string;
  discount_cause: string | null;
}

export interface UnifiedPlan {
  plan_name: string;
  description: string | null;
  monthly_plans: Record<string, PayPalPlan>;
  annual_plans: Record<string, PayPalPlan>;
}

export interface LifetimeStatus {
  available: boolean;
  current_tier: number | null;
  current_price: number | null;
  original_price: number | null;
  discount_percentage: number | null;
  slots_remaining: number;
  total_sold: number;
  user_has_lifetime: boolean;
  user_purchase_number: number | null;
  user_purchase_date: string | null;
}

